<template>
  <content-div>

    <step-bar :step="step" title="자동차등록증 촬영"></step-bar>

    <div class="contArea tpd">
      <div class="pictureArea">
        <div class="docuWrap">
          <div class="w50">
            <img :src="`${$store.state.dir}images/docu01.gif`">
          </div>
        </div>
        <p class="mgt1">가입할 차량의 자동차등록증 전면을<br>모든 내용이 잘 보이도록 촬영해 주세요.</p>

      </div>

      <button-apply
          before="/subscApply/term"
          @submit="regActivate = true;">
      </button-apply>
    </div>

    <popup-alert v-if="activate"
                 :title="termtitle"
                 :btn_cancel="true"
                 @close="popupClose">
      <div class="WBkeepAll" v-html="termContent"></div>
    </popup-alert>

    <popup-picture-ex
        v-if="regActivate"
        :type="Const.SUBSC_ATT.REG"
        @close="regclose">
    </popup-picture-ex>

  </content-div>
</template>


<script>
import Const from '../../../helpers/Const';
import ConstTerms from '../../../helpers/ConstTerms';
import StepBar from '@/components/StepBar.vue';
import ButtonApply from "@/components/Button/ButtonSubscApply.vue";
import PopupAlert from '@/components/Popup/PopupAlert.vue';
import PopupPictureEx from '@/components/Popup/PopupPictureEx.vue';


export default {
  beforeRouteEnter(to, from, next) {
    // if (
    //   from.name != 'SubscApplyTerm' &&  // 서비스 약관 동의
    //   from.name != 'SubscApplyVehicle'  // 구독차량정보입력
    // ) {
    //   alert('잘못된 접근경로 입니다.');
    //   this.$store.commit("unsetTerms");
    //   next('/')
    // } else {
    next();
    // }
  },

  components: {
    StepBar,
    ButtonApply,
    PopupAlert,
    PopupPictureEx,
  },

  created() {
    this.step = Number(this.$route.query.step);
    window.scroll(0, 0);
    this.activate = true;
  },

  data() {
    return {
      step: 0,
      Const,
      termType: ConstTerms.MASKING,
      content: '',
      terms:{
        [ConstTerms.MASKING] : false,
        [ConstTerms.MASKING_CHK] : false,
      },
      regActivate: false,
      activate: false,
      failCount:0,
    }
  },

  // jeon
  // termType = masking or masking_chk
  //사진 촬영후 masking 완료된 이미지의 확인 절차가 있었지만 masking의 시간적 이슈로 인해 사용 X
  // termType = masking 만 사용중


  computed: {
    termtitle(){
      let title = '';
      switch (this.termType) {
        case ConstTerms.MASKING: title = '자동차등록증 촬영'; break;
        case ConstTerms.MASKING_CHK: title = 'masking_chk'; break;
      }
      return title;
    },


    termContent() {
      let content = '';
      switch (this.termType) {
        case ConstTerms.MASKING: content = '회사는 자동차등록증에 기재된 정보 중 고객님께서 수집에 대해 동의하여 주신 정보만을 수집하며, 그 외 나머지 정보들은 기술적 조치를 통해 알아볼 수 없도록 처리됩니다. <br>정보 보호를 위해 촬영 관련 안내사항을 준수하여 주시기 바랍니다.'; break;
        case ConstTerms.MASKING_CHK:
          var img = (this.$store.state.isApp)
              ? this.$store.state.host.s3 + this.$store.state.att.vehicle.num_reg.path
              : 'https://s3.ap-northeast-2.amazonaws.com/bmw.prime.live/file/att/test_vehicle_img.jpg';
          content = `<img style="width:100%;" src="${img}"/>`;
          content = content + '<br>';
          content = content + 'masking 처리 확인';
          break;
      }
      return content;
    }
  },

  methods: {

    callOCRCarRegApi() {
      // api paramater setting
      //const plusId = this.$store.state.user.plus_id.toString();
      const vtgId = this.$store.state.user.vtg_id.toString();

      const handleKey = 'handleKey'; // 현재 실제로 사용하지는 않음

      // TODO : 임시 개발모드에서 카메라 사용하지 않도록 수정. 추후 카메라 사용할 수 있도록 해야할 필요 있음
      if (this.$store.state.isApp && !this.$store.state.isLocal) {
        /*global runOCRCarReg*/
        runOCRCarReg(vtgId, handleKey, this.S3UploadURL);
        this.$store.state.btnLoading = false;
        this.onload = true;
      } else if(this.$store.state.isDev) {
        this.nextStep();
      }

    },

    //app OCR 콜백 위치
    callbackOCRCarReg(value) {
      this.callbackOCRCarRegSet(value);
      this.nextStep();
    },

    regclose(bool) {
      this.regActivate = false;
      this.$store.commit('setBtnLoading', true);
      if(bool) return this.callOCRCarRegApi();
      // if(bool) return this.nextStep();

    },

    nextStep(){
      this.$store.commit("setTerm", {
        [ConstTerms.MASKING]: this.terms[ConstTerms.MASKING],
        [ConstTerms.MASKING_CHK]: this.terms[ConstTerms.MASKING_CHK]
      });
      this.$store.commit('setBtnLoading', false);
      // this.$router.push('/subscApply/vehicle');
      this.$router.push(`/subscApply/vehicleInsp?step=${this.step+1}`);
    },

    popupClose(value) {
      switch (this.termType) {
        case ConstTerms.MASKING:
          if(value) {//체크
            this.terms[ConstTerms.MASKING] = true;
            this.activate = false;
          } else { //취소
            this.$router.push('/');
          }
          break;

        case ConstTerms.MASKING_CHK:
          if(value) {//체크
            this.terms[ConstTerms.MASKING_CHK] = true;
            //masking 확인 사항도 db에 저장
            this.$store.commit("setTerm", {
              [ConstTerms.MASKING]: this.terms[ConstTerms.MASKING],
              [ConstTerms.MASKING_CHK]: this.terms[ConstTerms.MASKING_CHK]
            });
            this.$router.push('/subscApply/vehicle');
          } else {//취소
            this.activate = false;
          }
          break;
      }
    },
  },
}
</script>


<style lang="css" scoped>
</style>
